// extracted by mini-css-extract-plugin
module.exports = {"root":"📦Scanner__root--3Ts0e","centerWrapper":"📦Scanner__centerWrapper--2-Oag"};